export enum BadgeFormItem {
  BADGES = 'badges',
  NAME = 'name',
  ID = 'id',
  BACKGROUND_COLOR = 'backgroundColor',
  FONT_COLOR = 'fontColor',
  PROJECT_ID = 'projectId',
}
